import { render, staticRenderFns } from "./settings-container.vue?vue&type=template&id=260e0174"
import script from "./settings-container.vue?vue&type=script&lang=js"
export * from "./settings-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('260e0174')) {
      api.createRecord('260e0174', component.options)
    } else {
      api.reload('260e0174', component.options)
    }
    module.hot.accept("./settings-container.vue?vue&type=template&id=260e0174", function () {
      api.rerender('260e0174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/settings/account/components/settings-container.vue"
export default component.exports